import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { CONTROL, ELEVATION, MOTION, PRES } from '../chrome';
import { focusVisibleSx, reducedMotionSx } from './focus';

interface CardShellProps {
  children: React.ReactNode;
  onClick?: () => void;
  selected?: boolean;
  sx?: SxProps<Theme>;
}

const CardShell: React.FC<CardShellProps> = ({ children, onClick, selected = false, sx }) => (
  <Box
    component={onClick ? 'button' : 'div'}
    type={onClick ? 'button' : undefined}
    onClick={onClick}
    sx={{
      display: 'block',
      width: '100%',
      textAlign: 'left',
      p: 0,
      m: 0,
      borderRadius: `${CONTROL.radiusCard}px`,
      border: selected ? `1px solid ${PRES.interactive}` : `1px solid ${PRES.borderSubtle}`,
      bgcolor: PRES.surface,
      overflow: 'hidden',
      cursor: onClick ? 'pointer' : 'default',
      color: PRES.textPrimary,
      transition: `border-color ${MOTION.hover}, box-shadow ${MOTION.hover}`,
      '&:hover': onClick ? { borderColor: PRES.borderStrong, boxShadow: ELEVATION.cardHover } : undefined,
      ...focusVisibleSx,
      ...reducedMotionSx,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default CardShell;
